import {Button} from "react-bootstrap";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import {useTranslation} from "react-i18next";
import {TableHeaders} from "../utils/Enums/TableHeaders";
import {TaskReference} from "../models/dashboard-models";

export const ExportTasks = ({ csvData, fileName, wscols }:{csvData:TaskReference[],fileName:string,wscols:TableHeaders[]}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'table' });
    const { t: common } = useTranslation('translation', { keyPrefix: 'common' });

    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const headers = ["№", ...wscols.map((col) => t(col))];

    const calculateColumnWidths = (headers: string[], data: any[][]) => {
        return headers.map((header, colIndex) => {
            // Get max content length in column (including header)
            const maxContentWidth = Math.max(
                header.length,
                ...data.map(row => (row[colIndex] ? row[colIndex].toString().length : 0)) // Data length
            );
            return { wch: Math.max(10, maxContentWidth + 2) }; // Ensure min width of 10
        });
    };

    const exportToCSV = (csvData:TaskReference[],fileName:string)  => {
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        const formattedData = csvData.map((item, index) => [
            index + 1,
            item.completionTime == null ? common("noMaintenance") : item.completionTime,
            common(item.taskType),
            item.branchName,
            item.clientName,
            item.countDevices,
            item.consumables.join(", "),
            item.invoicePrice == null ? "-" : item.invoicePrice,
            item.paymentType == null
                ? "-"
                : common(item.documentType) + " " + common(item.paymentType.toLowerCase()),
            item.isTestPeriod
                ? common("testPeriodTo") + item.testDate
                : item.status == null
                    ? "-"
                    : common(item.status),
        ]);

        const totalInvoice = formattedData.reduce((sum, row) => {
            const value = typeof row[7] === "number" ? row[7] : 0; // Ensure it's a number
            return sum + value;
        }, 0);

        const totalDevices = formattedData.reduce((sum, row) => {
            const value = typeof row[5] === "number" ? row[5] : 0; // Ensure it's a number
            return sum + value;
        }, 0);

        const totalRow = [
            "", "", "", "", "", common("total")+": "+totalDevices, "", common("total") + ": " + totalInvoice.toFixed(2), "", ""
        ];
        formattedData.push(totalRow); // Append total row at the end

        XLSX.utils.sheet_add_json(ws, formattedData, {
            origin: "A2", // Ensure data starts from row 2
            skipHeader: true // Headers are already added
        });

        ws["!cols"] = calculateColumnWidths(headers, formattedData);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
        <Button
            variant="warning"
            className={"mb-2"}
            onClick={e => exportToCSV(csvData, fileName)}
        >
            {common('exportExcel')}
        </Button>
    );
};